import { Component } from '@angular/core';
import { SelectedCustomerService, CustomerListCardComponent } from 'gung-standard';
import { Router } from '@angular/router';

@Component({
    selector: 'ref-capstone-customer-list-card',
    templateUrl: './capstone-customer-list-card.component.html',
    styleUrls: ['./capstone-customer-list-card.component.scss'],
    standalone: false
})
export class CapstoneCustomerListCardComponent extends CustomerListCardComponent {
  constructor(selectCustomerService: SelectedCustomerService, protected router: Router) {
    super(selectCustomerService, router);
  }
}
